import { render } from "./ConfiguracaoFerramentaria.vue?vue&type=template&id=dc2af89a&scoped=true"
import script from "./ConfiguracaoFerramentaria.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoFerramentaria.vue?vue&type=script&lang=js"

import "./ConfiguracaoFerramentaria.vue?vue&type=style&index=0&id=dc2af89a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2af89a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn});
